<template>
	<div
		class="pointer-events-none absolute inset-0 z-10 flex items-center justify-center transition-all duration-500 ease-in-out"
		:class="loadingState ? 'visible opacity-100' : 'invisible opacity-0'"
	>
		<div
			class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"
		/>
	</div>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		loadingState?: boolean
	}>(),
	{
		loadingState: false,
	}
)
</script>
